/**
 *  @class
 *  @function InventoryNotice
 */
if (!customElements.get('inventory-notice')) {
  class InventoryNotice extends HTMLElement {
    connectedCallback() {
      this.cacheCurrentScale();

      this._observer = new MutationObserver(() => {
        this.animateBar();
      });
      this._observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }

    cacheCurrentScale() {
      const bar = this.querySelector('.product-inventory-notice--bar');
      this._lastScale = bar ? bar.style.getPropertyValue('--inventory-scale') : null;
    }

    animateBar() {
      const bar = this.querySelector('.product-inventory-notice--bar span');
      if (!bar || !this._lastScale) {
        this.cacheCurrentScale();
        return;
      }

      const newScale = bar.parentElement.style.getPropertyValue('--inventory-scale');

      // Set to old scale instantly (no transition), then transition to new scale
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(' + this._lastScale + ')';

      requestAnimationFrame(() => {
        bar.style.transition = '';
        bar.style.transform = '';
        this._lastScale = newScale;
      });
    }
  }
  customElements.define('inventory-notice', InventoryNotice);
}
